















































































import { Component, Vue, Emit, Prop, Ref } from "vue-property-decorator";
import AdUnit from "@/models/adUnit";
import FormValidations from "@/helpers/validations";
import { cloneDeep } from "lodash";
import { Form } from "@/models/general";
import SitesSelector from "@/components/SitesSelector.vue";
import SizesSelector from "@/components/SizesSelector.vue";
import DefinitionsSelector from "@/components/DefinitionsSelector.vue";

@Component({
  components: { SitesSelector, SizesSelector, DefinitionsSelector },
})
export default class AdUnitForm extends Vue {
  @Prop({ default: "ad_units.new" }) title!: string;
  @Prop() initialData?: AdUnit;
  @Ref("form") form!: Form;
  @Prop({ default: "create" }) readonly mode!: "edit" | "create";

  model: AdUnit = new AdUnit();
  formValidations = new FormValidations();
  loading = false;

  created(): void {
    if (this.initialData) this.model = cloneDeep(this.initialData);
  }

  validate(): void {
    const validForm = this.form.validate();
    validForm ? this.save() : null;
  }

  @Emit()
  save(): AdUnit {
    return this.model;
  }

  @Emit()
  cancel(): null {
    return null;
  }
}
